import { InjectionToken, ModuleWithProviders } from '@angular/core';
import { UiIconLibrary } from './icons-library';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import * as i0 from "@angular/core";
import * as i1 from "./icons-library";
export const ICONS_PROVIDER = /*#__PURE__*/new InjectionToken('ICONS_PROVIDER');
const iconFacebook = {
  prefix: 'fab',
  iconName: 'facebook',
  icon: [512, 512,
  // width/height
  [],
  // ligratures
  'f09a',
  // unicode
  'M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z']
};
const iconInstagram = {
  prefix: 'fab',
  iconName: 'instagram',
  icon: [448, 512,
  // width/height
  [],
  // ligratures
  'f16d',
  // unicode
  'M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z']
};
export const iconPlayRecentered = {
  prefix: 'fas',
  iconName: 'play-recentered',
  icon: [512, 512, [], "f2ba", "M123.5,509.3l358.7-240c9.5-6.3,9.5-20.3,0-26.6L123.5,2.7C112.9-4.4,98.6,3.2,98.6,16V496 C98.6,508.8,112.9,516.4,123.5,509.3z"]
};
export const iconPlayVideo = {
  prefix: 'fas',
  iconName: 'play-video',
  icon: [448, 512, [], "f2b9", "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"]
};
export let UiIconsModule = /*#__PURE__*/(() => {
  class UiIconsModule {
    static forRoot(icons) {
      return {
        ngModule: UiIconsModule,
        providers: [{
          provide: ICONS_PROVIDER,
          useValue: icons
        }]
      };
    }
    constructor(iconLib, icons) {
      if (!icons) throw new Error('found no provider for ICONS_PROVIDER. Each app should call UiIconsModule.forRoot in AppModule or their specific UiRequiredModule!');
      icons.forEach(i => i.prefix = 'fas'); // we want prefix to be ignored, so overwrite with default fas-prefix in all cases.
      iconLib.addIcons(...icons, iconFacebook, iconPlayRecentered, iconPlayVideo, iconInstagram, faCircleXmark);
    }
    static {
      this.ɵfac = function UiIconsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiIconsModule)(i0.ɵɵinject(i1.UiIconLibrary), i0.ɵɵinject(ICONS_PROVIDER, 8));
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: UiIconsModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({});
    }
  }
  return UiIconsModule;
})();